<template>
    <div>
        <div class="card mb-0" v-loading="loading">
            <div class="card-header bg-info">
                Anulación externa
            </div>
            <div class="card-body">
                <form autocomplete="off" @submit.prevent="submit">
                    <div class="form-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{'has-danger': errors.document_type_id}">
                                    <label class="control-label">Tipo comprobante</label>
                                    <el-select v-model="form.document_type_id" >
                                        <el-option v-for="option in document_types" :key="option.id" :value="option.id"
                                                :label="option.description"></el-option>
                                    </el-select>
                                    <small class="form-control-feedback" v-if="errors.document_type_id"
                                        v-text="errors.document_type_id[0]"></small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group" :class="{'has-danger': errors.customer_id}">
                                    <label class="control-label">Cliente</label>
                                    <el-select v-model="form.customer_id" filterable>
                                        <el-option v-for="option in customers" :key="option.id" :value="option.id"
                                                :label="option.description"></el-option>
                                    </el-select>
                                    <small class="form-control-feedback" v-if="errors.customer_id"
                                        v-text="errors.customer_id[0]"></small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group" :class="{'has-danger': errors.series}">
                                    <label class="control-label">Serie <span class="text-danger">*</span></label>
                                    <el-input v-model="form.series"></el-input>
                                    <small class="form-control-feedback" v-if="errors.series"
                                        v-text="errors.series[0]"></small>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" :class="{'has-danger': errors.number}">
                                    <label class="control-label">Número <span class="text-danger">*</span></label>
                                    <el-input v-model="form.number"></el-input>
                                    <small class="form-control-feedback" v-if="errors.number"
                                        v-text="errors.number[0]"></small>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" :class="{'has-danger': errors.date_of_reference}">
                                    <label class="control-label">Fec. Emisión</label>
                                    <el-date-picker v-model="form.date_of_reference" type="date" value-format="yyyy-MM-dd"
                                                    :clearable="false" @change="changeDateOfIssue"></el-date-picker>
                                    <small class="form-control-feedback" v-if="errors.date_of_reference"
                                        v-text="errors.date_of_reference[0]"></small>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group" :class="{'has-danger': errors.currency_type_id}">
                                    <label class="control-label">Moneda</label>
                                    <el-select v-model="form.currency_type_id">
                                        <el-option v-for="option in currency_types" :key="option.id" :value="option.id"
                                                :label="option.description"></el-option>
                                    </el-select>
                                    <small class="form-control-feedback" v-if="errors.currency_type_id"
                                        v-text="errors.currency_type_id[0]"></small>
                                </div>
                            </div>
                            
                            <div class="col-md-2">
                                <div class="form-group" :class="{'has-danger': errors.exchange_rate_sale}">
                                    <label class="control-label">Tipo de cambio
                                        <el-tooltip class="item" effect="dark"
                                                    content="Tipo de cambio del día, extraído de SUNAT" placement="top-end">
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                    </label>
                                    <el-input v-model="form.exchange_rate_sale"></el-input>
                                    <small class="form-control-feedback" v-if="errors.exchange_rate_sale"
                                        v-text="errors.exchange_rate_sale[0]"></small>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="form.document_type_id == '03'">
                            
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">Total gravado</label>
                                    <el-input v-model="form.total_gravado"></el-input>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">Total exonerado</label>
                                    <el-input v-model="form.total_exonerado"></el-input>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">Total inafecto</label>
                                    <el-input v-model="form.total_inafecto"></el-input>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">IGV</label>
                                    <el-input v-model="form.total_igv"></el-input>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" :class="{'has-danger': errors.total}">
                                    <label class="control-label">Total</label>
                                    <el-input v-model="form.total"></el-input>
                                    <small class="form-control-feedback" v-if="errors.total"
                                        v-text="errors.total[0]"></small>
                                </div>
                            </div>

                        </div>

                        <div class="row" v-else>
                            <div class="col-md-3">
                                <div class="form-group" :class="{'has-danger': errors.description}">
                                    <label class="control-label">Motivo anulación<span class="text-danger" v-if="form.document_type_id == '01'">*</span></label>
                                    <el-input v-model="form.description"></el-input>
                                    <small class="form-control-feedback" v-if="errors.description"
                                        v-text="errors.description[0]"></small>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="form-actions text-right mt-4">
                        <el-button @click.prevent="close()">Cancelar</el-button>
                        
                        <template>
                            <el-button type="primary" native-type="submit" :loading="loading_submit"
                                   >Generar
                            </el-button>
                        </template>
                    </div>
                </form>
            </div>

        </div>
    </div>
</template>

<script>
import { functions, exchangeRate } from "../../../mixins/functions";

export default {
    components: {},
    mixins: [functions, exchangeRate],
    props: ["configuration", "api_token"],
    data() {
        return {
            showDialogNewPerson: false,
            data_affected_document: {
                document_type_id: "01",
                series: null,
                number: null,
            },
            loading_search: false,
            loading_submit: false,
            loading: false,
            resource: "documents",
            errors: {},
            form: {},
            document_types: [],
            currency_types: [],
            customers: [],
            currency_type: {},
        };
    },
    async created() {
        await this.initForm();
        await this.$http.get(`/${this.resource}/tables`).then((response) => {
            this.document_types = response.data.document_types_invoice
            this.customers = response.data.customers
            this.currency_types = response.data.currency_types
            this.currency_type = _.find(this.currency_types, {
                id: this.form.currency_type_id,
            })

            this.changeDateOfIssue()
        });
        
    },
    mounted() {},
    computed: {
        
    },
    methods: {
        
        async initForm() {
            this.errors = {};
            this.form = {
                type: 'summary_external',
                state_type_id: "01",
                summary_status_type_id: "3",
                customer_id: null,
                document_type_id: "01",
                series: null,
                number: null,
                date_of_issue: moment().format("YYYY-MM-DD"),
                date_of_reference: moment().format("YYYY-MM-DD"),
                currency_type_id: "PEN",
                exchange_rate_sale: 0,
                total_gravado: 0,
                total_exonerado: 0,
                total_inafecto: 0,
                total_igv: 0,
                total: 0,
                description: null,
            }
        },
        
        changeDateOfIssue() {
            this.searchExchangeRateByDate(this.form.date_of_reference).then(
                (response) => {
                    this.form.exchange_rate_sale = response
                }
            )
        },
       
        
        async submit() {
            this.loading_submit = true
            this.form.type = this.form.document_type_id == '03' ? 'summary_external' : 'voided_external'
            
            this.resource =  this.form.document_type_id == '03' ? 'summary_external' : 'voided_external'
            this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$eventHub.$emit('reloadData')
                        this.$message.success(response.data.message)
                        this.close()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .then(() => {
                    this.loading_submit = false
                })
        },

        close() {
            location.href = "/documents"
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/documents/external_void.vue